import React, { FunctionComponent, ReactNode } from "react";
import { clsx } from "clsx";

interface DisabledWrapperProps {
  disabled?: boolean;
  children: ReactNode;
}

const DisabledWrapper = React.forwardRef<HTMLSpanElement, DisabledWrapperProps>(
  ({ children, disabled, ...triggerHandler }, ref) => (
    <span
      ref={ref}
      {...triggerHandler}
      className={clsx(disabled && "disabled-wrapper")}
    >
      {children}
    </span>
  )
);
export default DisabledWrapper;
